import { useState } from "react";
import "./styles.scss";
import { TabGroupProps } from "./types";

export default function TabGroup({ tabs, activeTab }: TabGroupProps) {
	const [active, setActive] = useState(activeTab || tabs[0].id);

	const getTabClassName = (tabName: string) =>
		tabName ? `tab__${tabName}` : "";

	return (
		<div className="tab-group">
			{tabs.map((tab) => (
				<div
					key={tab.id}
					onClick={() => {
						if (tab.onClick) tab.onClick();
						setActive(tab.id);
					}}
					className={`w-full text-center ${getTabClassName(tab.id)} ${
						active === tab.id ? "tab-active" : ""
					}`}
				>
					{tab.label}
				</div>
			))}
		</div>
	);
}
